import { useState } from "react";
import CamraIcon from "../../../components/Icons/CamraIcon";
import { useAtom } from "jotai";
import { imagesAtom } from "../../../jotai-store/uploadImagesPersistance";
import AddItemsManually from "../../../components/Booking/AddItemsManually";
import UploadImagesModal from "../../../components/Booking/UploadImagesModal";
import ImageGalleryModal from "../../../components/Booking/ImageGalleryModal";
import { useEffect } from "react";
import { v4 as uuidv4 } from 'uuid';
import AddItemsManually2 from "../../../components/Booking/AddItemsManually2";
import { showUploadModalAtom } from "../../../jotai-store/uploadImages";




const UploadImagesScreen = ({
  handleUpdateBookingObject,
  setVisionId,
  setVisionItemsLoading,
  setBookingTotalModel,
  setItems = () => {},
  setTripStatus = () => {},
  setEstimatePricing,
  setAddItems = () => {},


}) => {
  // State and Redux Hooks

  // const { loginInfo } = useSelector((state) => state.loginReducer);
  //`` State to manage selected images (jotai atom)
  const [selectedImages, setSelectedImages] = useAtom(imagesAtom);
  const [showUploadModal, setShowUploadModal] = useAtom(showUploadModalAtom);
  const [showGalleryModal, setShowGalleryModal] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  ///////////////////////////////////////////////////////////////////////

  // Handle image selection from file input
  const handleImageSelect = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;

    const inputId = e.target && e.target.id;
    const isCameraInput = inputId === "moving-images-camera";

    // Helper to convert files -> image objects
    const convertFiles = async (fileList) =>
      Promise.all(
        fileList.map(
          (file) =>
            new Promise((resolve) => {
              const reader = new FileReader();
              reader.onload = () => {
                resolve({
                  id: "Moovez-" + uuidv4(),
                  name: file.name,
                  type: file.type,
                  size: file.size,
                  lastModified: file.lastModified,
                  base64: reader.result,
                  file: file,
                  preview: URL.createObjectURL(file),
                });
              };
              reader.readAsDataURL(file);
            })
        )
      );

    if (isCameraInput) {
      // On camera input (iOS), always append new photos so taking multiple
      // photos doesn't replace previously taken ones.
      const processedImages = await convertFiles(files);
      const updated = [...selectedImages, ...processedImages];
      setSelectedImages(updated);
    } else {
      // Gallery input: keep previous replacement behavior by filename
      const existingNames = selectedImages.map((img) => img.name.toLowerCase());
      const filesToReplace = files.filter((file) =>
        existingNames.includes(file.name.toLowerCase())
      );
      const newFiles = files.filter(
        (file) => !existingNames.includes(file.name.toLowerCase())
      );

      const processedImages = await Promise.all(
        [...filesToReplace, ...newFiles].map(
          (file) =>
            new Promise((resolve) => {
              const reader = new FileReader();
              reader.onload = () => {
                resolve({
                  id: "Moovez-" + uuidv4(),
                  name: file.name,
                  type: file.type,
                  size: file.size,
                  lastModified: file.lastModified,
                  base64: reader.result,
                  file: file,
                  preview: URL.createObjectURL(file),
                });
              };
              reader.readAsDataURL(file);
            })
        )
      );

      // Replace logic: remove duplicates by filename, then append processed
      let updated = selectedImages.filter(
        (img) =>
          !filesToReplace.some(
            (f) => f.name.toLowerCase() === img.name.toLowerCase()
          )
      );
      updated = [...updated, ...processedImages];
      setSelectedImages(updated);
    }
    // Persistence to IndexedDB is handled by the `imagesAtom` (via idb-keyval).
    // No localStorage writes here — the atom will persist the new state.
    setShowUploadModal(false);
    setShowGalleryModal(true);
    // Reset file inputs so selecting the same file again will fire `onChange`
    try {
      const g = document.getElementById("moving-images-gallery");
      const c = document.getElementById("moving-images-camera");
      if (g) g.value = "";
      if (c) c.value = "";
    } catch (e) { }
  };

  // Handle camera click
  const handleCameraClick = () => {
    // Check if we're on a mobile device
    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    if (isMobile) {
      // On mobile, click the camera input (has capture attribute)
      const cameraInput = document.getElementById("moving-images-camera");
      if (cameraInput) cameraInput.click();
    } else {
      // On desktop/web, try to access camera first to check permissions but
      // still open the gallery/file-picker because desktop browsers don't
      // reliably open the native camera via file input.
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({
            video: {
              facingMode: "environment",
              width: { ideal: 1920 },
              height: { ideal: 1080 },
            },
          })
          .then((stream) => {
            // Camera access granted — open the gallery/file picker as fallback
            const galleryInput = document.getElementById(
              "moving-images-gallery"
            );
            if (galleryInput) galleryInput.click();
          })
          .catch((err) => {
            console.log("Camera access denied or not available:", err);
            // Fallback to regular file picker
            const galleryInput = document.getElementById(
              "moving-images-gallery"
            );
            if (galleryInput) galleryInput.click();
          });
      } else {
        // Fallback for older browsers
        const galleryInput = document.getElementById("moving-images-gallery");
        if (galleryInput) galleryInput.click();
      }
    }
  };

  // Handle file picker click
  const handleFilePickerClick = () => {
    const galleryInput = document.getElementById("moving-images-gallery");
    if (galleryInput) galleryInput.click();
  };

  // Handle take photo action
  const handleTakePhoto = () => {
    isMobile ? handleCameraClick() : handleFilePickerClick();
    setShowUploadModal(false);
  };

  // Open upload-choice modal from Add More button in gallery modal
  const handleAddMoreRequest = () => {
    setShowGalleryModal(false);
    setShowUploadModal(true);
  };

  // Use effects

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Ensure file input is reset when gallery modal closes (so same file can be re-selected)
  useEffect(() => {
    if (!showGalleryModal) {
      try {
        const g = document.getElementById("moving-images-gallery");
        const c = document.getElementById("moving-images-camera");
        if (g) g.value = "";
        if (c) c.value = "";
      } catch (e) { }
    }
  }, [showGalleryModal]);

  return (
    <div className="bg-[#F6F6FD] px-[33px] max-w-container">
      {/* MAIN TOP HEADING */}
      <div className="text-[#211F59] text-[24px] font-semibold font-instrument mb-6" style={{ lineHeight: "23px" }}>
        What are you moving?
      </div>

      {/* IMAGE Upload: separate hidden inputs for gallery and camera
          - gallery input: opens file picker / gallery on mobile and web
          - camera input: uses capture attribute to prefer camera on mobile
          Handlers will choose which input to click so behavior matches requirements */}
      <input
        type="file"
        accept="image/png, image/gif, image/jpeg"
        name="Select File"
        multiple={true}
        onChange={handleImageSelect}
        id="moving-images-gallery"
        style={{ display: "none" }}
      />

      <input
        type="file"
        accept="image/png, image/gif, image/jpeg"
        name="Take Photo"
        multiple={true}
        onChange={handleImageSelect}
        id="moving-images-camera"
        style={{ display: "none" }}
        capture="environment"
      />

      {/* Upload area - only show when no images are selected */}
      <div
        className="cursor-pointer bg-[#CDCCD7]  font-instrument h-[193.49px] flex flex-col items-center pt-[31px] pb-[17px] border border-[#7876A1] rounded-[8px]"
        onClick={() => {
          setShowUploadModal(true);
          ///If User Select New Images Then Clear All Local Storage Data
          localStorage.removeItem(`visionVehicle`);
          localStorage.removeItem(`isMinimized`);
          localStorage.removeItem(`visionReqId`);
          localStorage.removeItem(`uploadedFilesMeta`);
        
          localStorage.removeItem(`bookingId`);
          localStorage.removeItem(`VBItems`);
          setSelectedImages([]);

        }}
      >
        <CamraIcon className="mb-3" />

        <div className="text-[#211F59] font-semibold text-[16px] mb-1">
          Add photos
        </div>
        <div className="text-[12px] flex flex-col text-[#211F59] font-normal font-instrument w- text-center">
          <span className="sm:">Take or upload photos of all</span>
          <span>the items you’re moving.</span>
        </div>
      </div>

      {/* Add items manually If User Want to Add Items Manually */}
      {/* <AddItemsManually /> */}
      <AddItemsManually2 setShowUploadModal={setShowUploadModal} handleUpdateBookingObject={handleUpdateBookingObject} setAddItems={setAddItems} />

      {/* Upload Images Modal */}
      <UploadImagesModal
        isOpen={showUploadModal}
        onClose={() => setShowUploadModal(false)}
        onTakePhoto={handleTakePhoto}
        onChooseFromGallery={handleFilePickerClick}
        attachToParent={true}
        showGalleryModal={setShowGalleryModal}
        setBookingTotalModel={setBookingTotalModel}

      />

      {/* Image Gallery Modal Show Images In Gallery*/}
      <ImageGalleryModal
        isOpen={showGalleryModal}
        selectedImages={selectedImages}
        onClose={() => setShowGalleryModal(false)}
        onChooseFromGallery={handleFilePickerClick}
        handleUpdateBookingObject={handleUpdateBookingObject}
        setVisionId={setVisionId}
        setVisionItemsLoading={setVisionItemsLoading}
        handleTakePhoto={handleTakePhoto}
        isMobile={isMobile}
        setBookingTotalModel={setBookingTotalModel}
        setItems={setItems}
        setTripStatus={setTripStatus}
        setEstimatePricing={setEstimatePricing}
        onAddMoreRequest={handleAddMoreRequest}
      />
    </div>
  );
};

export default UploadImagesScreen;
